// extracted by mini-css-extract-plugin
export default {"serviceOption":"ServiceOption_serviceOption__oLPo-","title":"ServiceOption_title__jK3fn","description":"ServiceOption_description__s9dhw"};